// extracted by mini-css-extract-plugin
export var hideEditor = "_hs-2";
export var infoIcon = "_hs-3";
export var label = "_hs-1";
export var labelContainer = "_hs-0";
export var readonlyText = "_hs-4";